import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCol,{attrs:{"cols":"12","sm":"6","md":"4"}},[_c(VCard,{attrs:{"to":_vm.link}},[_c(VListItem,[_c(VListItemContent,[_c(VListItemTitle,{staticClass:"headline"},[_vm._v(_vm._s(_vm.title))]),_c(VListItemSubtitle,[_vm._v(_vm._s(_vm.subtitle))])],1)],1),_c(VImg,{attrs:{"width":"100%","height":"140px","src":_vm.img,"contain":""}}),_c(VCardActions,{staticClass:"text-center"},[_c(VSpacer),_c(VBtn,{attrs:{"text":"","color":"deep-purple accent-4","to":_vm.link}},[_vm._v(" "+_vm._s(_vm.$t("base.enter")))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }